<template>
  <div class="navigationComp " :class="{'openSideMenu' : isSideMenuActive == true }">
    <header class="d2-navigation" id="navigation">
        <div class="d2-navigation__inner boxed">
            <div class="d2-navigation_left">
              <div class="menuIcon" id="dashboardMenu">
                <span></span>
              </div>
              <router-link :to="auth_gamebox === 'loggedin' ? '/home' : ''" class="logo">
                <img src="../../assets/gamebox/imgs/gamebox-logo.png" />
              </router-link>
              <Search v-if="auth_gamebox === 'loggedin'"/>
            </div>
            <div class="d2-navigation__right">
              <div class="panelWrap">
                <div v-if="country_gamebox != 'iq'" class="userAccount">
                  <router-link :to="auth_gamebox === 'loggedin' ? '/profile' : ''">  
                      <div class="userAccount__image">
                        <img src="../../assets/gamebox/imgs/dummy_account.jpeg" />
                    </div>
                      <div class="userAccount__name">
                        <p>{{$t("hello")}}</p>
                      </div>
                  </router-link>
                </div>
                  <span class="icon flaticon-bell" id="notificationIcon"></span>
                  <div class="translationBtns">
                    <button class="d2-button dropdown-toggle dropdown-toggle-split" id="btn1"  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <div v-html="button" id="lang1"></div>
                    </button>
                    <!-- <button type="button" class="btn btn-danger dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <span class="sr-only">Toggle Dropdown</span>
                    </button> -->
                    <div class="dropdown-menu" id="dropdown-menu">
                      <button class="dropdown-item" id="btn2" v-on:click="getTranslateDesktop()"><div v-html="langButton_gamebox" id="lang2"></div></button>
                    </div>
                  </div>
                  <div id="notification" data-att="" class="d2-navigation__notificationWrap">
                    <Notification v-if="auth_gamebox === 'loggedin'"/>
                  </div>
              </div>
              <button class="menuBtn" id="menuBtn" @click="openSideMenu()"><span class="menuBtn__inner">menu</span></button>
            </div>
           
        </div>
    </header>
    <nav class="d2-btmMenu" v-if="auth_gamebox === 'loggedin'">
      <div class="d2-btmMenu__inner boxed">
          <ul class="d2-navLinks">
        <li class="d2-navLinks__item">
          <router-link to="/home">{{
            $t("home")
          }}</router-link>
        </li>
        <li class="d2-navLinks__item">
          <a href="#">{{ $t("game_categories") }}</a>
          <ul class="subLinks">
            <li class="subLinks__item " v-for="cat in $props.browse.category" :key="cat.key">
              <router-link :to="{name: 'Subcategory', params: { subcategory: cat.route }}" >
                <span :class="cat.icon" class="icon"></span>
                <span>{{ cat[`title_${lang_gamebox}`] }}</span>
              </router-link>
              </li>
          </ul>
        </li>
        
        <li class="d2-navLinks__item">
          <router-link
            style="text-decoration:none;"
            to="/hotpicks">
            <span class="flaticon-flame icon"></span>
            <span>{{ $t("hotpicks") }}</span>
            </router-link>
        </li>
        <li class="d2-navLinks__item">
          <router-link
            style="text-decoration:none;"
            to="/popular">
            <span class="flaticon-graph icon"></span>
            <span> {{ $t("popular") }}</span>
            </router-link>
        </li>
        <li class="d2-navLinks__item">
              <router-link to="/privacy" c>
                <span class="flaticon-padlock icon"></span>
                <span>{{ $t("privacy") }}</span>
                </router-link>
            </li>
          <li v-if="countryCode === 'sk' || countryCode === 'cz'" class="d2-navLinks__item">
              <router-link to="/terms">
                <span class="flaticon-padlock icon"></span>
                <span>{{ $t("terms") }}</span>
              </router-link>
          </li>
      </ul>
      </div>
    </nav>
    <nav class="d2-siteNavMobile" >
      <div class="d2-siteNavMobile__wraper">
           <div  v-if="country_gamebox != 'iq'" class="userAccount" @click="openSideMenu()">
              <router-link :to="auth_gamebox === 'loggedin' ? '/profile' : ''" >  
                  <div class="userAccount__image">
                    <img src="../../assets/gamebox/imgs/dummy_account.jpeg" />
                </div>
              </router-link>
            </div>
            <div class="translationBtns">
              <button class="d2-button" id="btn1" v-on:click="getTranslateMobile('btn1')" v-if="lang_gamebox != 'english'"><div v-html="button" id="lang1"></div></button>
              <button class="d2-button" id="btn2" v-on:click="getTranslateMobile('btn2')" v-else><div v-html="langButton_gamebox" id="lang2"></div></button>
            </div>
          <nav v-if="auth_gamebox === 'loggedin'">
            <ul class="d2-navLinks">
              <li class="d2-navLinks__item" @click="openSideMenu()">
                 <router-link to="/home">{{
                  $t("home")
                }}</router-link>
              </li>
               <li class="d2-navLinks__item">
                  <a href="#">{{ $t("game_categories") }} </a>
                  <ul class="subLinks">
                    <li class="subLinks__item " v-for="cat in $props.browse.category" :key="cat.key" @click="openSideMenu()">
                      <router-link :to="{name: 'Subcategory', params: { subcategory: cat.route }}"  >
                        <span :class="cat.icon" class="icon"></span>
                        <span>{{ cat[`title_${lang_gamebox}`] }}</span>
                      </router-link>
                      </li>
                  </ul>
              </li>
            </ul>
          </nav>
          <ul class="d2-navLinks footer">
            <li class="d2-navLinks__item">
              <router-link to="/privacy" c>
                <span class="flaticon-padlock icon"></span>
                <span>{{ $t("privacy") }}</span>
                </router-link>
            </li>
            <li v-if="countryCode === 'sk' || countryCode === 'cz'" class="d2-navLinks__item">
              <router-link to="/terms">
                <span class="flaticon-information-button icon"></span>
                <span>{{ $t("terms") }}</span>
              </router-link>
          </li>
            <li class="d2-navLinks__item" v-if="auth_gamebox === 'loggedin'">
              <div class="navLinks__item" v-if="is_unsub_gamebox != '0'">
                  <a class="d2-button d2-button--alert" @click="logout_gamebox(is_unsub_gamebox)">
                    {{ $t("unsubscribe") }}
                  </a>
              </div>
              <div class="navLinks__itm" v-else>
                  <a v-if="countryCode !== 'fi'" class="d2-button d2-button--alert" @click="logout_gamebox(is_unsub_gamebox)" href="/logout">
                    {{ $t("unsubscribe") }}
                  </a>
              </div>
            </li>
          </ul>

      </div>
      <div class="closeNav">
        <div class="menuIcon" id="navMobileClose">
          <span></span>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import gamebox from "../../router/gamebox";
import gameboxData from "./gamebox";
import Search from "../gamebox/Search.vue";
import Notification from "../gamebox/Notification.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      button: `<span lang="english">
        <img class="flag" lang="english" src="https://i.imgur.com/ISR1V1s.png" />
        <span lang="english">English</span>
        </span>`,
      isSideMenuActive: false
    };
  },
  props: ["browse"],
  components: {
    Search,
    Notification
  },
  computed: mapGetters([
    "langButton_gamebox",
    "lang_gamebox",
    "auth_gamebox",
    "country_gamebox",
    "is_unsub_gamebox",
    "countryCode"
  ]),
  mounted() {
    this.fetchTranslateButton_gamebox(this.country_gamebox);
    this.butnLang();

    const dropdown = document.getElementById("dropdown-menu");

    if (this.country_gamebox == "ke" || this.country_gamebox == "ke1") {
      dropdown.style.display = "none";
    }

    const notificationIcon = document.getElementById("notificationIcon");
    const notificationPanel = document.getElementById("notification");

    //notification
    notificationIcon.addEventListener("click", e => {
      notificationPanel.classList.toggle("show");
    });
    //Body listen clicks

    document.addEventListener("click", event => {
      let isClickedInside =
        notificationPanel.contains(event.target) ||
        notificationIcon.contains(event.target);

      if (!isClickedInside) {
        notificationPanel.classList.remove("show");
      }
    });
    //init menu
  },
  methods: {
    ...mapActions([
      "fetchLocale_gamebox",
      "fetchTranslateButton_gamebox",
      "logout_gamebox"
    ]),
    butnLang() {
      const btnLang1 = document.getElementById("lang1");
      const btnLang2 = document.getElementById("lang2");

      const btn1 = document.getElementById("btn1");
      const btn2 = document.getElementById("btn2");
      this.$nextTick(() => {
        if (this.lang_gamebox == "english") {
          btn1.innerHTML = btnLang1.innerHTML;
          btn2.innerHTML = btnLang2.innerHTML;
        } else if (this.lang_gamebox != "english") {
          btn1.innerHTML = btnLang2.innerHTML;
          btn2.innerHTML = btnLang1.innerHTML;
        }
      });
    },
    getTranslateDesktop() {
      const btn1 = document.getElementById("btn1");
      const btn2 = document.getElementById("btn2");

      let lang = document
        .getElementById("btn2")
        .children[0].getAttribute("lang");

      let temp = btn1.innerHTML;
      btn1.innerHTML = btn2.innerHTML;
      btn2.innerHTML = temp;

      this.$i18n.locale = lang;
      this.fetchLocale_gamebox(lang);
      localStorage.setItem("lang_gamebox", lang);
      if (lang == "arabic") {
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
      } else {
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      }
    },
    getTranslateMobile(btn) {
      const btn1 = document.getElementById("btn1");
      const btn2 = document.getElementById("btn2");

      let btnLang = "";
      // const btnLang2 = document.getElementById("lang2");
      if (btn == "btn1") {
        btnLang = document.getElementById("lang1");
      } else {
        btnLang = document.getElementById("lang2");
      }
      let lang = btnLang.children[0].getAttribute("lang");
      this.$i18n.locale = lang;
      this.fetchLocale_gamebox(lang);
      localStorage.setItem("lang_gamebox", lang);
      if (lang == "arabic") {
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
      } else {
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      }

      this.getTranslateDesktop();
    },
    openSideMenu() {
      this.isSideMenuActive = !this.isSideMenuActive;
    },

    initTopNavScroll() {
      const navbar = document.getElementById("d2-navigation");

      document
        .getElementsByTagName("html")[0]
        .addEventListener("wheel", hideOnScrollHeader);
      function hideOnScrollHeader() {
        let hasClass = document.body.classList.contains("mobile--active");

        if (event.wheelDeltaY < 0 && !hasClass) {
          navbar.classList.add("stick", "hide");
          document.body.classList.remove("mobile--active");
        } else {
          document;
          navbar.classList.remove("stick", "hide");
        }
      }
    },
    logout() {
      localStorage.removeItem("userToken_gamebox");
      localStorage.removeItem("logged-in");
      //router.push({name: Login}).catch(err => {})
    }
  },
  watch: {
    $route(to, from) {
      if (from.name == "Category" && to.name == "Category") {
        location.reload();
      }
      // if(from.name == "HotPicks" && to.name == "HotPicks"){
      //   location.reload();
      // }
      // this.$router.push(`/category/game-2`)
      // react to route changes...
    }
  }
};
</script>

<style lang="css" scoped>
@import url("../../assets/gamebox/fonts/gamebox/flaticon.css");
</style>
<style lang="scss" scoped>
.navigationComp {
  position: fixed;
  z-index: 999;
  width: 100%;
  top: 0;
  a:hover {
    color: #4aeb80;
  }
}
.subLinks {
  display: none;
  position: absolute;
  top: 46px;
  left: 0;
  width: 220px;
  background-color: #00183e;
}
.subLinks__item {
  a {
    padding: 1em;
    &:hover {
      color: #fff;
      background: #4aeb80;
    }
  }
}
.d2-navigation__notificationWrap {
  display: none;
  position: absolute;
  right: 10%;
  top: 54px;
}
.d2-navigation__notificationWrap.show {
  display: block;
}
#search {
  display: none;
}

.d2-navigation {
  position: relative;
  top: 0px;
  z-index: 99;
  transition: transform 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  background: #00183e;
  .d2-navigation__inner {
    height: 68px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: visible;
  }
  .icon::before {
    color: #01112b;
    cursor: pointer;
    margin: 0;
  }
}
.d2-btmMenu {
  width: 100%;
  background: rgba(0, 24, 62, 0.35);
  transition: all 0.45s;
  .d2-btmMenu__inner {
    overflow: visible;
  }
  &:hover {
    background: rgba(0, 24, 62, 1);
  }
}
.d2-navigation.stick {
  transform: translateY(-78px);
}
.logo {
  width: 130px;
  display: inline-block;
  img {
    width: 100%;
  }
}

.translationBtns {
  position: relative;
  display: inline-block;
  margin-left: 15px;
  .d2-button {
    padding: 0;
    background: transparent;
    outline: none;
    img {
      margin-right: 5px;
      width: 36px;
    }
  }
}
.siteNavMobile {
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 240px;
  background: #fff;
  transform: translateX(-240px);
  transition: transform 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  box-shadow: 0 0 14px 6px rgba(0, 0, 0, 0.3);
  .siteNavMobile__wraper {
    display: flex;
    flex-direction: column;
    padding: 2rem 0;
    justify-content: space-between;
    overflow-y: auto;
    width: 100%;
    height: 100%;
  }
  .closeNav {
    position: absolute;
    right: 0px;
    width: 82px;
    text-align: right;
    top: 21px;
    border-radius: 19px;
    background-color: #fff;
  }
  .menuIcon {
    margin: 0;
    display: inline-block;
    vertical-align: middle;
  }
  .menuIcon:before,
  .menuIcon:after {
    background-color: #172ef0;
    height: 3px;
    width: 21px;
  }
}
.mobile--active .closeNav {
  right: -35px;
}
.d2-navLinks {
  list-style: none;
  padding: 0;
  margin: 0;
  .d2-navLinks__item {
    padding: 15px 0px;
    margin: 0px 25px 0px 0px;
    display: inline-block;
    vertical-align: middle;
    a {
      font-size: 1.2rem;
      font-weight: 600;
    }
  }
  .d2-navLinks__item {
    a {
      font-size: 1.2rem;
      &:hover {
        text-decoration: none;
      }
      &:before {
        font-size: 24px !important;
      }
    }
    span {
      display: inline-block;
      vertical-align: middle;
    }
    .icon + span {
      margin-left: 8px;
    }
  }
  .d2-navLinks__item.xs {
    a {
      font-size: 1rem;
      text-decoration: none;
      &:before {
        font-size: 21px !important;
      }
    }
  }
}
.d2-navLinks__item {
  position: relative;
  .icon::before {
    margin: 0;
    font-weight: 400;
  }
  &:hover .subLinks {
    display: block;
  }
}
.footer {
  margin: 0px -2rem;
  // border-top: 1px solid #4aeb80;
  // .d2-navLinks__item {
  //   padding: 15px 2rem;
  // }
}

// .mobile--active .navigation {

//   width: 100%;
// }
// .mobile--active .siteNavMobile {
//   -webkit-transform: translateX(0);
//   -ms-transform: translateX(0);
//   transform: translateX(0);
// }
// .mobile--active .menuIcon::before {
//   color: #fff;
//   -webkit-transform: translateY(9px) rotate(135deg);
//   -ms-transform: translateY(9px) rotate(135deg);
//   transform: translateY(9px) rotate(135deg);
// }
// .mobile--active .menuIcon::after {
//   color: #fff;
//   -webkit-transform: translateY(-9px) rotate(45deg);
//   -ms-transform: translateY(-9px) rotate(45deg);
//   transform: translateY(-9px) rotate(45deg);
// }
// .mobile--active .menuIcon > span::before {
//   opacity: 0;
//   -webkit-transition-duration: 0.1s;
//   -o-transition-duration: 0.1s;
//   transition-duration: 0.1s;
// }
.userAccount {
  text-align: center;
  position: relative;
  display: inline-block;
  vertical-align: middle;
}
.userAccount__image {
  width: 42px;
  height: 42px;
  margin: 0 auto;
  border-radius: 5px;
  display: inline-block;
  vertical-align: middle;
  border: 1px solid #fff;
  img {
    width: 100%;
    border-radius: 5px;
  }
}
.userAccount__name {
  display: inline-block;
  vertical-align: middle;
  p {
    margin: 0;
    font-weight: 500;
    font-size: 1rem;
    padding-left: 5px;
  }
}
.panelWrap {
  span {
    display: inline-block;
    vertical-align: middle;
    background: #fff;
    padding: 6px;
    border-radius: 5px;
    margin-left: 15px;
  }
}
/*##### Responsive layout Styles#####*/
.menuBtn {
  display: none;
  border: 0;
  background: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  position: relative;
  width: 34px;
  height: 30px;
  cursor: pointer;
  outline: none;
  &::before,
  &:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 34px;
    height: 2px;
    background-color: #fff;
    transition-property: transform, color, opacity;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
    -webkit-transform-origin: center;
    transform-origin: center;
  }
  &::before {
    top: 5px;
  }
  &::after {
    top: 23px;
  }
}
.menuBtn__inner {
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-align: left;
  text-indent: 100%;
  white-space: nowrap;
  cursor: pointer;
  &::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 34px;
    height: 2px;
    background-color: #fff;
    transition-property: transform, color, opacity;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
    -webkit-transform-origin: center;
    transform-origin: center;
    top: 14px;
  }
}

.openSideMenu {
  .menuBtn {
    &::before,
    &::after {
      color: #fff;
    }
    &::before {
      transform: translateY(9px) rotate(135deg);
    }
    &::after {
      transform: translateY(-9px) rotate(45deg);
    }
  }
  .menuBtn__inner {
    &::before {
      opacity: 0;
      transition-duration: 0.1s;
    }
  }
  .d2-siteNavMobile {
    transform: translateX(0);
  }
}

.d2-siteNavMobile {
  overflow: auto;
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  width: 100%;
  color: #fff;
  background: #00183e;
  transform: translateX(100%);
  transition: transform 0.6s cubic-bezier(0.075, 0.82, 0.165, 1),
    -webkit-transform 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  .subLinks {
    display: block;
    position: relative;
    top: 0;
    max-height: 320px;
    width: 100%;
    overflow: auto;
  }
  .d2-navLinks__item {
    display: block;
  }
  .d2-navLinks__item a {
    font-size: 1.6rem;
  }
  .subLinks__item a {
    font-size: 1.2rem;
    padding: 0.9em;
  }
  .userAccount__image {
    width: 68px;
    height: 68px;
  }
  .footer {
    a {
      font-size: 1rem;
    }
  }
  .translationBtns {
    display: block;
    margin: 15px 0px;
    .d2-button {
      text-align: left;
    }
  }
  nav {
    border-top: 1px solid #4aeb80;
    border-bottom: 1px solid #4aeb80;
    margin: 0px -2rem;
  }
  .d2-navLinks {
    padding: 0px 2rem;
  }
}
.d2-siteNavMobile__wraper {
  padding: 75px 1rem 2rem;
}
@media (max-width: 991px) {
  .menuBtn,
  .d2-siteNavMobile {
    display: block;
  }
  .panelWrap,
  .d2-btmMenu {
    display: none;
  }
}

@media (max-width: 589px) {
  .logo {
    width: 100px;
  }
}
/*##### Arabic layout Styles#####*/
.ar_layout {
  .mobile--active .closeNav {
    left: -35px;
    right: auto;
    text-align: left;
  }
  .siteNavMobile {
    transform: translateX(240px);
    right: 0;
    left: auto;
  }
  .mobile--active .siteNavMobile {
    -webkit-transform: translateX(0);
    -ms-transform: translateX(0);
    transform: translateX(0);
  }

  .navigation__notificationWrap {
    right: auto;
    left: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/gamebox/Navigation.vue